import { NumberInput, ReadOnlyInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import { Collapse, Grid, IconButton, Tooltip } from '@material-ui/core';
import SelectProdutoServico from 'app/components/Select/SelectProdutoServico';
import SelectProdutoVenda from 'app/components/Select/SelectProdutoVenda';
import { produtoApi } from 'app/services/api/produtoApi';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { MdHighlightOff, MdSettings } from 'react-icons/md';
import { produtoServicoItemStyles } from './styles';

const getCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

const ProdutoServicoItem = ({
  id,
  errors,
  touched,
  name,
  values,
  arrayHelpers,
  index,
  onChange,
  onRemove,
  onBlur,
  submitCount,
  atualizarAliquota,
  retencaoAliquota,
  disabled,
  exibeMsgProdutoSemEstoque = true,
  aceitaProdutoImobilizado = false,
  soProduto,
  origemIntegracao,
}) => {
  const [open, setOpen] = useState(false);
  const formik = useFormikContext();

  useEffect(() => {
    setOpen(true);
  }, []);

  const { setFieldValue } = formik;
  useEffect(() => {
    const { produtosServicos } = formik?.values;

    produtosServicos.map(async (ps) => {
      if (
        ps?.produtoServico?.produtoId &&
        (ps?.produtoServico?.quantidadeEstoqueProduto === undefined ||
          ps?.produtoServico?.quantidadeEstoqueProduto === null)
      ) {
        const resp = await produtoApi.getOne(ps?.produtoServico?.produtoId);
        ps.produtoServico.quantidadeEstoqueProduto = resp.data.quantidadeEstoque;
      }
    });

    setFieldValue('produtosServicos', produtosServicos);
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setFieldValue]);

  const styles = produtoServicoItemStyles();

  const motivoVenda = formik?.values?.motivoVenda;

  const _errors = {
    produtoServico: (submitCount > 0 || touched?.produtoServico) && errors?.produtoServico,
    quantidade: (submitCount > 0 || touched?.quantidade) && errors?.quantidade,
    valor: (submitCount > 0 || touched?.valor) && errors?.valor,
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRemove = () => {
    arrayHelpers.remove(index);
    onRemove(values);
  };

  const maximo9DigitosEsquerda = (values) => {
    return !values.floatValue || values.floatValue <= 10 ** 9;
  };

  const possuiRetencaoNaFonte =
    values?.servicoFiscal?.issRetidoNaFonte ||
    values?.servicoFiscal?.pisRetidoNaFonte ||
    values?.servicoFiscal?.cofinsRetidoNaFonte ||
    values?.servicoFiscal?.inssRetidoNaFonte ||
    values?.servicoFiscal?.irrfRetidoNaFonte ||
    values?.servicoFiscal?.csllRetidoNaFonte;

  const getSubTotal = () => {
    if (!values?.quantidade || values?.valor === '' || values?.valor == null) {
      return '-';
    }
    if (values.subtotalCalculado != null && values.subtotalCalculado !== '') {
      return getCurrency(Number(values.subtotalCalculado));
    }
    return getCurrency(values.quantidade * values.valor);
  };

  let tooltip;
  const tooltipProduto = values?.produto?.descricaoDetalhada;
  const tooltipServico = values?.servico?.descricaoDetalhada;
  const tooltipProdutoServico = values?.produtoServico?.descricaoDetalhada;

  if (tooltipProduto) tooltip = tooltipProduto;
  if (tooltipServico) tooltip = tooltipServico;
  if (tooltipProdutoServico) tooltip = tooltipProdutoServico;

  return (
    <Collapse in={open} onExited={handleRemove}>
      <Grid container spacing={3} className="mt-2">
        <Grid item xs={4} className={styles.produtoServicoNomeContainer}>
          <Grid item xs={11}>
            {soProduto ? (
              <SelectProdutoVenda
                id={`${id}.produtoServico`}
                name={`${name}.produtoServico`}
                error={_errors.produtoServico}
                touched={!!_errors.produtoServico}
                onChange={(e) => onChange(e, values?.key, index)}
                onBlur={onBlur}
                value={values?.produtoServico}
                disabled={disabled || origemIntegracao}
                aceitaProdutoImobilizado={aceitaProdutoImobilizado}
              />
            ) : (
              <SelectProdutoServico
                id={`${id}.produtoServico`}
                name={`${name}.produtoServico`}
                error={_errors.produtoServico}
                touched={!!_errors.produtoServico}
                onChange={(e) => onChange(e, values?.key, index)}
                onBlur={onBlur}
                value={values?.produtoServico}
                disabled={disabled || origemIntegracao}
                soProduto={soProduto}
              />
            )}
          </Grid>
          <Grid item xs={1} className={styles.containerInfo}>
            {tooltip && (
              <Tooltip title={tooltip} placement="right-end">
                <button type="button" onClick={() => {}}>
                  <FaInfoCircle size={18} style={{ color: '#555' }} />
                </button>
              </Tooltip>
            )}
          </Grid>
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id={`${id}.quantidade`}
            decimalScale={4}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={maximo9DigitosEsquerda}
            onChange={(e) => onChange(e, values?.key)}
            onBlur={onBlur}
            value={values?.quantidade}
            error={_errors.quantidade}
            touched={!!_errors?.quantidade}
            required
            warning={
              values?.quantidade > values?.produtoServico?.quantidadeEstoqueProduto &&
              (!values?.produtoServico.imobilizado && motivoVenda === 'VENDA_PADRAO' && exibeMsgProdutoSemEstoque
                ? 'Produto sem estoque'
                : '')
            }
            disabled={disabled || origemIntegracao}
          />
        </Grid>
        <Grid item xs={2}>
          <CurrencyTextField
            id={`${id}.valor`}
            name={`${id}.valor`}
            value={values?.valor}
            outputFormat="number"
            currencySymbol=""
            decimalCharacter=","
            digitGroupSeparator="."
            maximumValue="999999999"
            minimumValue="0"
            decimalPlaces={3}
            decimalPlacesShownOnBlur={3}
            decimalPlacesShownOnFocus={3}
            error={_errors.valor}
            helperText={_errors.valor}
            touched={!!_errors?.valor}
            onChange={(e, value) => {
              onChange({
                target: {
                  id: `${id}.valor`,
                  value: e.target.value === '' ? '' : value,
                },
              });
            }}
            onKeyUp={(e, value) => {
              onChange({
                target: {
                  id: `${id}.valor`,
                  value: e.target.value === '' ? '' : value,
                },
              });
            }}
            onBlur={onBlur}
            fullWidth
            required
            variant="outlined"
            disabled={disabled}
          />
        </Grid>

        <Grid item xs={2}>
          {possuiRetencaoNaFonte ? (
            <Tooltip title="Valor final considerando as retenções do serviço pelo cliente" placement="bottom-end">
              <div>
                <ReadOnlyInput id={`${id}.subtotal`} value={getSubTotal()} />
              </div>
            </Tooltip>
          ) : (
            <div>
              <ReadOnlyInput id={`${id}.subtotal`} value={getSubTotal()} />
            </div>
          )}
        </Grid>
        <Grid className={styles.containerInfo} item xs={1} sm={1} md={1} lg={1} xl={1}>
          {values?.produtoServico?.produtoId && (
            <Tooltip title="Atualizar alíquotas" placement="right-end">
              <IconButton onClick={() => atualizarAliquota(index)}>
                <MdSettings size={18} />
              </IconButton>
            </Tooltip>
          )}
          {values?.produtoServico?.servicoId && (
            <Tooltip title="Atualizar alíquotas" placement="right-end">
              <IconButton onClick={() => retencaoAliquota(index)}>
                <MdSettings size={18} />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
        <Grid className={styles.containerInfo} item xs={1} sm={1} md={1} lg={1} xl={1}>
          {index > 0 && (
            <Tooltip title="Excluir" placement="right-end">
              <IconButton onClick={handleClose}>
                <MdHighlightOff size={18} />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    </Collapse>
  );
};

export default ProdutoServicoItem;
